import React from 'react';
import { IconArrow5, GlobalIcons } from '@creditas-ui/react';
import { Button as ButtonElement } from './RoundedButton.style';
import { ButtonProps } from './types';

const RoundedButton = ({
  arrow,
  disabled,
  onClick,
  'data-testid': dataTestid = 'button',
  ...props
}: ButtonProps): JSX.Element => {
  const buttonProps = { arrow, disabled, onClick, 'data-testid': dataTestid };
  const svgDataTestid = `${dataTestid}-icon`;

  return (
    <ButtonElement {...buttonProps} {...props}>
      <GlobalIcons Icon={IconArrow5} size="large" data-testid={svgDataTestid} />
    </ButtonElement>
  );
};

export { RoundedButton };
